import i18n from '@/lib/i18n'
import UTCDateTime from '@/lib/utc-datetime'

import store from '@/store'
import moment from 'moment'

const THIS_YEAR = moment().year()

/** @deprecated */
export default class Product {
  static getProductsByFieldPk(field) {
    if (!field) {
      return []
    }
    const products = store.getters.products
    const pk = field.pk
    let results = []
    for (let i = 0; i < products.length; i++) {
      const product = products[i]
      const fieldPkList = product.fieldPkList
      // check contains
      if (fieldPkList.indexOf(pk) >= 0) {
        results.push(product)
      }
    }
    return results
  }

  static getCropName(product) {
    const language = i18n.getUserLang()
    let cropName = product.crop.localizedNames[language]
    if (!cropName) {
      cropName = product.crop.localizedNames.default
    }
    if (cropName) {
      return cropName
    }
    return ''
  }

  static getCropVarietyName(product) {
    const language = i18n.getUserLang()
    const cropVariety = product.cropVariety
    if (cropVariety) {
      const name = cropVariety.localizedNames[language]
      if (name) {
        return name
      }
    }
    return ''
  }

  static isCurrent(product) {
    return THIS_YEAR === product.year
  }

  static isSameYearWithTask(product, task) {
    const taskStartedAt = UTCDateTime.toUtcMoment(task.startTime)
    const productYear = product.year
    if (taskStartedAt.year() === productYear) {
      return true
    }
    return false
  }

  static getUniqueCrops() {
    const products = store.getters.products
    let uniqueIdList = []
    let list = []
    for (let i = 0; i < products.length; i++) {
      const product = products[i]
      if (product) {
        const crop = product.crop
        if (crop) {
          const cropId = crop.id
          if (!uniqueIdList.includes(cropId)) {
            uniqueIdList.push(cropId)
            list.push(crop)
          }
        }
      }
    }
    return list
  }

  static getCropNameList() {
    const products = store.getters.products
    let list = []
    for (let i = 0; i < products.length; i++) {
      const product = products[i]
      const cropName = Product.getCropName(product)
      if (list.indexOf(cropName) === -1) {
        list.push(cropName)
      }
    }
    return list
  }

  static getCropVarietyNameList(editingCropName) {
    if (!editingCropName) {
      return []
    }
    const products = store.getters.products
    let list = []
    for (let i = 0; i < products.length; i++) {
      const product = products[i]
      const cropVariety = product.cropVariety
      if (cropVariety) {
        const cropName = Product.getCropName(product)
        if (editingCropName === cropName) {
          const cropVarietyName = Product.getCropVarietyName(product)
          if (list.indexOf(cropVarietyName) === -1) {
            list.push(cropVarietyName)
          }
        }
      }
    }
    return list
  }
}
